module.exports = __webpack_public_path__ + "img/vertical-logo.c22d678b.svg";